export class NonConvergenceError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "NonConvergenceError";
  }
}
